<div [ngClass]="isMobile() ? 'mobile-header' : ''" class="header-container">
    <img width="134px" height="46px" src="assets/img/logo-concello.png" alt="Concello logo">
    <h4 class="planificator-title">{{'routeForm.planificatorTitle' | transloco}} </h4>
    <button mat-icon-button (click)="closeSidenav()" class="settings-button">
        <mat-icon class="close-icon" fontIcon="close"></mat-icon>
    </button>
</div>

<ng-template #mobileButton>
    <button mat-icon-button (click)="closeSidenav()" class="settings-button">
        <mat-icon class="close-icon" fontIcon="close"></mat-icon>
    </button>
</ng-template>